import { type AutocompleteProps } from "@mantine/core";
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form";
import { Autocomplete as MantineAutocomplete } from "src/components/shared/MantineCombobox";

interface Props<T extends FieldValues> extends AutocompleteProps {
  name: Path<T>;
  control: Control<T>;
}

function Autocomplete<T extends FieldValues>({
  name,
  control,
  ...props
}: Props<T>) {
  const { field } = useController({
    name,
    control,
  });

  return <MantineAutocomplete {...props} {...field} />;
}

export default Autocomplete;
